<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-10-10 14:15:55
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-10-10 14:42:57
 * @FilePath: \qctsw-vue\packages\app\src\components\base\list.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import type { LOAD_STATE } from '~/shared/types'

const props = withDefaults(defineProps<{
  state?: LOAD_STATE

  direction?: 'top' | 'bottom' | 'left' | 'right'
  offset?: number
  endText?: string
  loadingText?: string
  loadMoreText?: string
  errorText?: string
}>(), {
  state: 'loadMore',
  direction: 'bottom',
  offset: 10,
  endText: '没有更多了',
  loadingText: '加载中...',
  loadMoreText: '加载更多',
  errorText: '加载失败',
})

const emits = defineEmits({
  'update:state': (state: LOAD_STATE) => typeof state === 'string',
  'load': () => true,
})
// const DEFAULT_ELEMENT = ref(isClient ? document : null)

const stateText = computed(() => props[`${props.state}Text`])
const loadStateRef = ref<HTMLElement | null>(null)

function loadHandle() {
  if (!['loadMore', 'error', 'end'].includes(props.state))
    return
  emits('load')
}

onMounted(() => {
  const intersectionObserver = new IntersectionObserver((entries, observer) => {
    if (entries[0].intersectionRatio <= 0)
      return
    loadHandle()
  })

  loadStateRef.value && intersectionObserver.observe(loadStateRef.value)
})
</script>

<template>
  <div v-bind="$attrs" class="list-wrapper">
    <slot />
    <!-- {{ state }} -->
  </div>
  <div ref="loadStateRef" class="pt-3 pb-4 flex items-center justify-center cursor-pointer" @click="loadHandle">
    <span v-if="props.state === 'loading'" class="i-bx:loader-circle" />
    <span class="text-title-400">{{ stateText }}</span>
  </div>
</template>
